module.exports = __webpack_public_path__ + "img/1-1.5戴军（主持人）.f49e85e4.jpg";